import DateEditorPanel from './DateEditorPanel';
import { toDateKey } from './dateUtils';

export default function DayView({ currentDate, weeklySlots, slotOverrides, bookings = [], onSaveOverride, onResetOverride, readOnly }) {
  return (
    <DateEditorPanel
      key={toDateKey(currentDate)}
      variant="inline"
      date={currentDate}
      weeklySlots={weeklySlots}
      slotOverrides={slotOverrides}
      bookings={bookings}
      onSaveOverride={onSaveOverride}
      onResetOverride={onResetOverride}
      readOnly={readOnly}
    />
  );
}
